import lcmApiClient from "./lcmApiClient";
import { extractAsset } from "../extractors/assetsExtractor";
import { extractInstrumentations } from "../extractors/instrumentationsExtractor";

/* istanbul ignore next */
export async function loadAsset(id: $TSFixMe, parameters: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const assetResponse = await lcmApiClient(false).get(
    `/assets/${id}`,
    parameters,
  );
  return extractAsset(assetResponse);
}

/* istanbul ignore next */
export async function loadExtendedOrderCodeLookup(asset: $TSFixMe) {
  let response = null;
  // prettier-ignore
  // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
  response = (
    // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
    await lcmApiClient().get("/endress/extended_order_code_lookup", {
      order_code: asset.specifications["eh.pcps.tmp.ordercode"].value,
    })
  ).extended_order_code;
  return response;
}

/* istanbul ignore next */
export async function unassignNodeFromAsset(
  assetId: $TSFixMe,
  nodeId: $TSFixMe,
) {
  return lcmApiClient().delete(`/assets/${assetId}/nodes`, {
    nodes: [{ id: nodeId }],
  });
}

/* istanbul ignore next */
export async function loadAssetInstrumentations(
  id: $TSFixMe,
  parameters: $TSFixMe,
) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().getAll(
    `/assets/${id}/instrumentations`,
    parameters,
  );
  return extractInstrumentations(response);
}

/* istanbul ignore next */
export async function assignInstrumentationToAsset(
  assetId: $TSFixMe,
  instrumentationId: $TSFixMe,
) {
  return lcmApiClient().post(`/assets/${assetId}/instrumentations`, {
    instrumentations: [{ id: instrumentationId }],
  });
}
